import Vue from 'vue'
import { decode } from '@/lib/util'

Vue.component('product-description', {
  props: ['settingsData'],
  data () {
    const sectionSettings = JSON.parse(decode(this.settingsData)) || {
      items: [],
      title: '',
      sidebarTitle: '',
      sidebarDescription: '',
      sidebarButtonLink: '',
      sidebarButtonText: ''
    }
    return {
      ...sectionSettings
    }
  },
})